/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const JobState = {
    New: 'New',
    InExecution: 'InExecution',
    Paused: 'Paused',
    Completed: 'Completed',
    ReviewPending: 'ReviewPending',
    InReview: 'InReview',
    ReworkRequested: 'ReworkRequested',
    Approved: 'Approved'
} as const;
export type JobState = typeof JobState[keyof typeof JobState];


export function JobStateFromJSON(json: any): JobState {
    return JobStateFromJSONTyped(json, false);
}

export function JobStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobState {
    return json as JobState;
}

export function JobStateToJSON(value?: JobState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the JobState interface.
 */
 export function instanceOfJobState(value: any): value is JobState {
    return Object.values(JobState).includes(value)
}

